(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8996],{

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ CardsList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/antd/es/row/index.js
var row = __webpack_require__(71230);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/Button/index.tsx
var Button = __webpack_require__(5172);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/shared/CardsList/style.module.scss
var style_module = __webpack_require__(25089);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/libs/context/index.js
var context = __webpack_require__(58218);
;// CONCATENATED MODULE: ./src/components/shared/CardsList/CardItem/index.tsx







var CategoryItem = function(param) {
    var cardImage = param.cardImage, title = param.title, _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl, cardType = param.cardType, backgroundColor = param.backgroundColor, _cardDescription = param.cardDescription, cardDescription = _cardDescription === void 0 ? "" : _cardDescription, AllowedUsers = param.AllowedUsers;
    var guestUser = (0,react.useContext)(context/* AppContext */.I).guestUser;
    var customLoader = function(param) {
        var src = param.src;
        return src;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: cardType === "top-categories" || cardType === "welcome-banner" ? guestUser || !guestUser && AllowedUsers === "Registered" && cardType === "welcome-banner" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: redirectUrl,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: (style_module_default()).CategoryItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundImage: "url(".concat(cardImage === null || cardImage === void 0 ? void 0 : cardImage.url, ")")
                            },
                            className: "".concat((style_module_default()).CategoryImage, " mb-12"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%",
                                    height: "100%",
                                    position: "relative"
                                }
                            })
                        }, title),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "".concat((style_module_default()).CardTitle, " font-semibold-h5 lh-sm text-oxfordBlue text-center"),
                            children: title
                        }),
                        cardDescription !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-regular-xs lh-lg text-center text-oxfordBlue",
                            style: {
                                maxWidth: "200px"
                            },
                            children: cardDescription
                        })
                    ]
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: redirectUrl,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "".concat((style_module_default()).CardItem, " px-20 py-12 font-semibold-sm lh-sm}"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    title: title,
                    className: "text-oxfordBlue",
                    children: title
                })
            })
        }) : cardType === "shop-by-business" ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: redirectUrl,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "".concat((style_module_default()).CardItem, " px-4 py-4 font-semibold-sm lh-sm}"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    title: title,
                    className: "text-oxfordBlue",
                    children: title
                })
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: redirectUrl,
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: classnames_default()((style_module_default()).CategoryItem, (style_module_default()).BrandItem),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            style: {
                                backgroundColor: backgroundColor
                            },
                            className: "".concat((style_module_default()).CategoryImage, " mb-12 p-22"),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    width: "100%",
                                    height: "100%",
                                    position: "relative"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    loader: customLoader,
                                    src: cardImage ? cardImage === null || cardImage === void 0 ? void 0 : cardImage.url : "",
                                    alt: cardImage && (cardImage === null || cardImage === void 0 ? void 0 : cardImage.altText) || "card image",
                                    layout: "fill",
                                    objectFit: "contain"
                                })
                            })
                        }, title),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "".concat((style_module_default()).CardTitle, " font-semibold-h5 lh-sm text-oxfordBlue text-center"),
                            children: title
                        }),
                        cardDescription !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "font-regular-xs lh-lg text-center text-oxfordBlue",
                            style: {
                                maxWidth: "200px"
                            },
                            children: cardDescription
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var CardItem = (CategoryItem);

// EXTERNAL MODULE: ./src/libs/resources/index.js + 1 modules
var resources = __webpack_require__(41090);
// EXTERNAL MODULE: ./src/utilities/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(53547);
;// CONCATENATED MODULE: ./src/components/shared/CardsList/index.tsx










var CategoryList = function(param) {
    var sectionTitle = param.sectionTitle, subSection = param.subSection, _btnText = param.btnText, btnText = _btnText === void 0 ? "View All" : _btnText, _btnUrl = param.btnUrl, btnUrl = _btnUrl === void 0 ? "" : _btnUrl, _cardType = param.cardType, cardType = _cardType === void 0 ? "top-categories" : _cardType, items = param.items, _AllowedUsers = param.AllowedUsers, AllowedUsers = _AllowedUsers === void 0 ? "Both" : _AllowedUsers, _forMixedPallet = param.forMixedPallet, forMixedPallet = _forMixedPallet === void 0 ? false : _forMixedPallet;
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (0,react.useState)(false), isGuestUser = ref5[0], setIsGuestUser = ref5[1];
    var ref6 = (0,react.useContext)(context/* AppContext */.I), guestUser = ref6.guestUser, customerStatus = ref6.customerStatus;
    var windowWidth = (0,useWindowResize/* useWindowResize */.w)();
    var cardClass = classnames_default()((style_module_default()).Categories, forMixedPallet && (style_module_default()).featuredVendors);
    (0,react.useEffect)(function() {
        setIsGuestUser(guestUser);
    }, [
        guestUser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isGuestUser && (AllowedUsers === "Guest" || AllowedUsers === "Both") && /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                className: "bg-white ".concat(AllowedUsers === "Guest" && cardType === "top-categories" && (style_module_default()).CategoriesWithImage, " ").concat(AllowedUsers === "Guest" && cardType === "shop-by-business" && (style_module_default()).GuestBusiness),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((style_module_default()).CardContainer, " container py-35  ").concat(cardType === "shop-by-business" && (style_module_default()).businessContainer, " ").concat(cardType === "shop-by-brand" && (style_module_default()).ShopByBrand),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "".concat((style_module_default()).SectionTitle, " font-bolder-lg lh-sm"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: sectionTitle
                                }),
                                cardType === "shop-by-brand" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    theme: "link",
                                    href: btnUrl,
                                    className: "".concat((style_module_default()).CardButton, " font-bold-sm lh-sm ms-6 mt-2"),
                                    children: btnText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: cardClass,
                            children: items === null || items === void 0 ? void 0 : items.map(function(param, index) {
                                var cardImage = param.cardImage, title = param.title, _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl, backgroundColor = param.backgroundColor, _cardDescription = param.cardDescription, cardDescription = _cardDescription === void 0 ? "" : _cardDescription;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardItem, {
                                    cardImage: cardImage,
                                    title: title,
                                    redirectUrl: redirectUrl,
                                    backgroundColor: backgroundColor,
                                    cardType: cardType,
                                    cardDescription: cardDescription,
                                    AllowedUsers: AllowedUsers
                                }, index);
                            })
                        })
                    ]
                })
            }),
            !isGuestUser && (AllowedUsers === "Registered" || AllowedUsers == "Both") && (AllowedUsers === "Registered" && cardType === "welcome-banner" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                className: "bg-white ".concat((style_module_default()).CategoriesWithImage, " ").concat(cardType === "welcome-banner" ? (style_module_default()).WelcomeBanner : ""),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((style_module_default()).CardContainer, " container pt-35 pb-18"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "".concat(windowWidth < 992 ? "font-bolder-h3" : "font-bolder-xl", "  mb-4"),
                            children: (customerStatus === null || customerStatus === void 0 ? void 0 : customerStatus.contact_name) ? "".concat(sectionTitle, " ").concat((ref1 = customerStatus === null || customerStatus === void 0 ? void 0 : (ref = customerStatus.contact_name) === null || ref === void 0 ? void 0 : ref.split(" ")) === null || ref1 === void 0 ? void 0 : ref1[0]) : (ref2 = (0,resources/* getText */.Q)()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.SignUp) === null || ref3 === void 0 ? void 0 : ref3.welcomeToEPallet
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-regular-base ".concat(windowWidth < 992 ? "mb-20" : "mb-25"),
                            children: subSection
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: cardClass,
                            children: [
                                items === null || items === void 0 ? void 0 : items.map(function(param, index) {
                                    var cardImage = param.cardImage, title = param.title, _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl, backgroundColor = param.backgroundColor, _cardDescription = param.cardDescription, cardDescription = _cardDescription === void 0 ? "" : _cardDescription;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardItem, {
                                        cardImage: cardImage,
                                        title: title,
                                        redirectUrl: redirectUrl,
                                        cardType: cardType,
                                        backgroundColor: backgroundColor,
                                        cardDescription: cardDescription,
                                        AllowedUsers: AllowedUsers
                                    }, index);
                                }),
                                (ref4 = items === null || items === void 0 ? void 0 : items.slice(0, 6 - (items === null || items === void 0 ? void 0 : items.length))) === null || ref4 === void 0 ? void 0 : ref4.map(function(param, index) {
                                    var cardImage = param.cardImage, title = param.title, _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl, backgroundColor = param.backgroundColor, _cardDescription = param.cardDescription, cardDescription = _cardDescription === void 0 ? "" : _cardDescription;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardItem, {
                                        cardImage: cardImage,
                                        title: title,
                                        redirectUrl: redirectUrl,
                                        cardType: cardType,
                                        backgroundColor: backgroundColor,
                                        cardDescription: cardDescription,
                                        AllowedUsers: AllowedUsers
                                    }, index);
                                })
                            ]
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "".concat((style_module_default()).CardContainer, " shopByBrands container pt-35 pb-10"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "".concat((style_module_default()).SectionTitle, " font-bolder-lg lh-sm"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: sectionTitle
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    theme: "link",
                                    href: btnUrl,
                                    className: "".concat((style_module_default()).CardButton, " font-bold-sm lh-sm ms-6 mt-2"),
                                    children: btnText
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: cardClass,
                            children: items === null || items === void 0 ? void 0 : items.map(function(param, index) {
                                var cardImage = param.cardImage, title = param.title, _redirectUrl = param.redirectUrl, redirectUrl = _redirectUrl === void 0 ? "" : _redirectUrl, backgroundColor = param.backgroundColor, _cardDescription = param.cardDescription, cardDescription = _cardDescription === void 0 ? "" : _cardDescription;
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CardItem, {
                                    cardImage: cardImage,
                                    title: title,
                                    redirectUrl: redirectUrl,
                                    backgroundColor: backgroundColor,
                                    cardType: cardType,
                                    cardDescription: cardDescription,
                                    AllowedUsers: AllowedUsers
                                }, index);
                            })
                        })
                    ]
                })
            }))
        ]
    });
};
/* harmony default export */ var CardsList = (CategoryList);


/***/ }),

/***/ 14029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/Hero/styles.module.scss
var styles_module = __webpack_require__(92997);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/shared/Button/index.tsx
var Button = __webpack_require__(5172);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./src/libs/context/index.js
var context = __webpack_require__(58218);
// EXTERNAL MODULE: ./src/utilities/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(53547);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/shared/HaggleModal/HaggleModal.tsx
var HaggleModal = __webpack_require__(88802);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/OptimizedHeroImage.module.scss
var OptimizedHeroImage_module = __webpack_require__(220);
var OptimizedHeroImage_module_default = /*#__PURE__*/__webpack_require__.n(OptimizedHeroImage_module);
;// CONCATENATED MODULE: ./src/components/OptimizedHeroImage.tsx








var OptimizedHeroImage = function(_param) {
    var src = _param.src, alt = _param.alt, _className = _param.className, className = _className === void 0 ? "" : _className, _priority = _param.priority, priority = _priority === void 0 ? true : _priority, _sizes = _param.sizes, sizes = _sizes === void 0 ? "100vw" : _sizes, _quality = _param.quality, quality = _quality === void 0 ? 75 : _quality, _preload = _param.preload, preload = _preload === void 0 ? true : _preload, width = _param.width, height = _param.height, blurDataURL = _param.blurDataURL, props = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "className",
        "priority",
        "sizes",
        "quality",
        "preload",
        "width",
        "height",
        "blurDataURL"
    ]);
    var ref = (0,react.useState)(true), isLoading = ref[0], setIsLoading = ref[1];
    var ref1 = (0,react.useState)(false), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(false), isLoaded = ref2[0], setIsLoaded = ref2[1];
    var preloadLinkRef = (0,react.useRef)(null);
    // Use native preload for critical images with proper fetch priority
    (0,react.useEffect)(function() {
        if (priority && preload && "object" !== "undefined") {
            // Remove any existing preload link
            if (preloadLinkRef.current && preloadLinkRef.current.parentNode) {
                preloadLinkRef.current.parentNode.removeChild(preloadLinkRef.current);
            }
            // Create new preload link with high fetch priority
            var link = document.createElement("link");
            link.rel = "preload";
            link.as = "image";
            link.href = src;
            link.fetchPriority = "high";
            link.type = "image/webp"; // Add type hint for modern formats
            document.head.appendChild(link);
            preloadLinkRef.current = link;
            return function() {
                if (preloadLinkRef.current && preloadLinkRef.current.parentNode) {
                    preloadLinkRef.current.parentNode.removeChild(preloadLinkRef.current);
                    preloadLinkRef.current = null;
                }
            };
        }
    }, [
        src,
        priority,
        preload
    ]);
    // Handle image loading state
    var handleLoad = function() {
        setIsLoaded(true);
        // Reduce the timeout to improve perceived performance
        setTimeout(function() {
            setIsLoading(false);
        }, 50);
    };
    // Calculate aspect ratio for the container
    var aspectRatio = width && height ? "".concat(width, "/").concat(height) : "16/9";
    // Generate responsive sizes based on viewport
    var responsiveSizes = sizes || "(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            priority && preload && /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: src,
                    type: "image/webp"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "".concat((OptimizedHeroImage_module_default()).container, " ").concat(className),
                "data-placeholder-for": src,
                style: {
                    aspectRatio: aspectRatio,
                    backgroundColor: "#f0f0f0"
                },
                children: [
                    isLoading && !isLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (OptimizedHeroImage_module_default()).placeholder,
                        style: {
                            backgroundImage: blurDataURL ? "url(".concat(blurDataURL, ")") : undefined,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            filter: blurDataURL ? "blur(20px)" : undefined
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((OptimizedHeroImage_module_default()).imageContainer, " ").concat(isLoaded ? (OptimizedHeroImage_module_default()).loaded : (OptimizedHeroImage_module_default()).loading),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                            src: error ? "/fallback-hero.jpg" : src,
                            alt: alt,
                            priority: priority,
                            sizes: responsiveSizes,
                            quality: quality,
                            className: className,
                            loading: priority ? "eager" : "lazy",
                            decoding: "async",
                            onLoad: handleLoad,
                            onError: function() {
                                return setError(true);
                            },
                            placeholder: blurDataURL ? "blur" : "empty",
                            blurDataURL: blurDataURL,
                            style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props.style), {
                                position: "absolute",
                                inset: 0,
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                willChange: "transform"
                            })
                        }))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_OptimizedHeroImage = (OptimizedHeroImage);

;// CONCATENATED MODULE: ./src/components/shared/Hero/index.tsx












var Hero = function(param) {
    var image = param.image, mobileImage = param.mobileImage, heading = param.heading, subHeading = param.subHeading, linkLabel = param.linkLabel, linkLabelMobile = param.linkLabelMobile, linkUrl = param.linkUrl, AllowedUsers = param.AllowedUsers, promotionID = param.promotionID;
    var router = (0,next_router.useRouter)();
    var isMovePage = (router === null || router === void 0 ? void 0 : router.asPath) === "/move" ? true : false;
    var guestUser = (0,react.useContext)(context/* AppContext */.I).guestUser;
    var ref = (0,react.useState)(false), openModal = ref[0], setOpenModal = ref[1];
    var isMobile = (0,useWindowResize/* useWindowResize */.w)() <= 576;
    var isTablet = (0,useWindowResize/* useWindowResize */.w)() <= 768;
    var ref1 = (0,react.useState)(undefined), isGuestUser = ref1[0], setIsGuestUser = ref1[1];
    var checkIfGuest = isGuestUser && AllowedUsers === "Registered" || !isGuestUser && AllowedUsers === "Guest";
    (0,react.useEffect)(function() {
        setIsGuestUser(guestUser);
    }, [
        guestUser
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: typeof checkIfGuest !== "undefined" && !checkIfGuest ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat((router === null || router === void 0 ? void 0 : router.asPath) === "/move" ? (styles_module_default()).moveHeroContainer : "", " ").concat((styles_module_default()).heroContainer),
            style: {
                aspectRatio: isTablet ? "".concat((mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.width) || 375, "/").concat((mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.height) || 388) : "".concat((image === null || image === void 0 ? void 0 : image.width) || 3200, "/").concat((image === null || image === void 0 ? void 0 : image.height) || 1106)
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).imageWrapper,
                children: [
                    isTablet ? (mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OptimizedHeroImage, {
                        src: mobileImage.url,
                        alt: mobileImage.altText || "Mobile Hero",
                        className: (styles_module_default()).heroImage,
                        priority: true,
                        preload: true,
                        sizes: "(max-width: 768px) 100vw, 100vw",
                        quality: 85,
                        layout: "fill",
                        width: mobileImage.width,
                        height: mobileImage.height,
                        blurDataURL: mobileImage.url.replace(/\.(jpg|jpeg|png|webp)$/, "-blur.webp")
                    }) : (image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_OptimizedHeroImage, {
                        src: image.url,
                        alt: image.altText || "Desktop Hero",
                        className: (styles_module_default()).heroImage,
                        priority: true,
                        preload: true,
                        sizes: "(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px",
                        quality: 85,
                        layout: "fill",
                        width: image.width,
                        height: image.height,
                        blurDataURL: image.url.replace(/\.(jpg|jpeg|png|webp)$/, "-blur.webp")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat([
                            (styles_module_default()).heroContentContainer
                        ].join(" "), " ").concat((router === null || router === void 0 ? void 0 : router.asPath) === "/move" ? (styles_module_default()).moveHeroContentContainer : ""),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: [
                                            (styles_module_default()).heading,
                                            isMobile ? "font-bolder-lg" : "font-black-xxxl", 
                                        ].join(" "),
                                        children: (0,html_react_parser/* default */.ZP)(heading || "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: [
                                            "mb-10 font-regular-",
                                            isMobile ? "base" : "h5", 
                                        ].join(""),
                                        children: (0,html_react_parser/* default */.ZP)(subHeading || "")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: isMovePage ? "" : linkUrl,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            onClick: function(event) {
                                                if (isMovePage) {
                                                    event.preventDefault();
                                                    setOpenModal(true);
                                                } else {
                                                    return;
                                                }
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                className: (styles_module_default()).linkBtn,
                                                theme: "primary",
                                                children: isMobile ? linkLabelMobile || linkLabel : linkLabel
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HaggleModal/* default */.Z, {
                                title: "Contact Us",
                                subTitle: "Let us share how Move can unlock your logistics",
                                isModalOpen: openModal,
                                setIsModalOpen: setOpenModal
                            })
                        ]
                    })
                ]
            })
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
    });
};
/* harmony default export */ var shared_Hero = (Hero);


/***/ }),

/***/ 65971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_shared_Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81394);
/* harmony import */ var _src_libs_resources__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41090);
/* harmony import */ var _requestForm__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64671);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(40273);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_shared_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5172);
/* harmony import */ var _src_libs_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58218);
var ref, ref1, ref2, ref3;








function RequestProduct(param) {
    var AllowedUsers = param.AllowedUsers, title = param.title, buttonLabel = param.buttonLabel;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var guestUser = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_src_libs_context__WEBPACK_IMPORTED_MODULE_6__/* .AppContext */ .I).guestUser;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), isGuestUser = ref1[0], setIsGuestUser = ref1[1];
    var showModal = function() {
        setIsModalOpen(true);
    };
    var checkIfGuest = isGuestUser && AllowedUsers === "Registered" || !isGuestUser && AllowedUsers === "Guest";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsGuestUser(guestUser);
    }, [
        guestUser
    ]);
    return !checkIfGuest ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().noResult), " py-20"),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_Icon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    name: "find_product",
                    width: 54,
                    height: 54
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().title),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().requestItBtn),
                theme: "primary",
                onClick: showModal,
                children: buttonLabel
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_requestForm__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                setIsModalOpen: setIsModalOpen,
                isModalOpen: isModalOpen
            })
        ]
    }) : null;
}
RequestProduct.defaultProps = {
    title: (ref = (0,_src_libs_resources__WEBPACK_IMPORTED_MODULE_3__/* .getText */ .Q)()) === null || ref === void 0 ? void 0 : (ref1 = ref.Search) === null || ref1 === void 0 ? void 0 : ref1.canNotFindAProduct,
    buttonLabel: (ref2 = (0,_src_libs_resources__WEBPACK_IMPORTED_MODULE_3__/* .getText */ .Q)()) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.Search) === null || ref3 === void 0 ? void 0 : ref3.requestIt
};
/* harmony default export */ __webpack_exports__["Z"] = (RequestProduct);


/***/ }),

/***/ 63177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(536);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _components_shared_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5172);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25935);
/* harmony import */ var _src_libs_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58218);
/* harmony import */ var _src_utilities_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(53547);








var SimplySellMore = function(param) {
    var image = param.image, mobileImage = param.mobileImage, heading = param.heading, subHeading = param.subHeading, linkLabel = param.linkLabel, linkLabelMobile = param.linkLabelMobile, linkUrl = param.linkUrl, AllowedUsers = param.AllowedUsers, promotionID = param.promotionID;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isMobile = (0,_src_utilities_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__/* .useWindowResize */ .w)() <= 576;
    var isTablet = (0,_src_utilities_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__/* .useWindowResize */ .w)() <= 992;
    var isSmallScreen = (0,_src_utilities_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_6__/* .useWindowResize */ .w)() < 1200;
    var guestUser = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_src_libs_context__WEBPACK_IMPORTED_MODULE_5__/* .AppContext */ .I).guestUser;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), isGuestUser = ref[0], setIsGuestUser = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsGuestUser(guestUser);
    }, [
        guestUser
    ]);
    var stringToHTML = function stringToHTML(str) {
        var dom = document.createElement("div");
        dom.innerHTML = str;
        return dom;
    };
    var checkIfGuest = isGuestUser && AllowedUsers === "Registered" || !isGuestUser && AllowedUsers === "Guest";
    return typeof checkIfGuest !== "undefined" && !checkIfGuest ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().heroContainer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().heroImage),
                    style: {
                        height: "auto",
                        minHeight: isSmallScreen && !isTablet ? "460px" : ""
                    },
                    src: isMobile ? mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url : image === null || image === void 0 ? void 0 : image.url,
                    alt: isMobile ? mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.altText : image === null || image === void 0 ? void 0 : image.altText
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: [
                        (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().heroContentContainer)
                    ].join(" "),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: [
                                    (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().heading),
                                    isTablet ? "font-bolder-h2" : isSmallScreen ? "font-bolder-xl" : "font-bolder-xxl"
                                ].join(" "),
                                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(heading || "")
                            }),
                            !isTablet && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "mb-20 text-white font-regular-h5",
                                children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(subHeading || "")
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_7___default().linkBtn),
                                theme: "primary-inverse",
                                onClick: function() {
                                    return router.push("/?epallet_signup=true");
                                },
                                children: isMobile ? linkLabelMobile || linkLabel : linkLabel
                            })
                        ]
                    })
                })
            ]
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (SimplySellMore);


/***/ }),

/***/ 220:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"OptimizedHeroImage_container__xhNxB","placeholder":"OptimizedHeroImage_placeholder__me0l_","shimmer":"OptimizedHeroImage_shimmer__0PViu","imageContainer":"OptimizedHeroImage_imageContainer__EbyZF","loaded":"OptimizedHeroImage_loaded__M6fGu","loading":"OptimizedHeroImage_loading__gkpVW"};

/***/ }),

/***/ 25089:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CardContainer":"style_CardContainer__vLu1G","featuredVendors":"style_featuredVendors__pLPBf","CategoriesWithImage":"style_CategoriesWithImage__4iBhN","WelcomeBanner":"style_WelcomeBanner__8yOUh","Categories":"style_Categories__k_WO5","CategoryItem":"style_CategoryItem___Bm8P","SectionTitle":"style_SectionTitle__3FI79","CategoryImage":"style_CategoryImage__Na97H","businessContainer":"style_businessContainer__qRZjP","CardItem":"style_CardItem__VbAaF","ShopByBrand":"style_ShopByBrand__8qmQl","BrandItem":"style_BrandItem__CiCQK","CardTitle":"style_CardTitle__OtHIH"};

/***/ }),

/***/ 92997:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"styles_heroContainer__aM8Db","imageWrapper":"styles_imageWrapper__Ruuzy","heroImage":"styles_heroImage__YWGtR","heroContentContainer":"styles_heroContentContainer__lSxUr","moveHeroContentContainer":"styles_moveHeroContentContainer__9VecJ","heading":"styles_heading__EK_4a","linkBtn":"styles_linkBtn__xiVaA"};

/***/ }),

/***/ 40273:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"noResult":"style_noResult__xdv4I","title":"style_title__CtkK5","requestItBtn":"style_requestItBtn__t2_MY"};

/***/ }),

/***/ 536:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroContainer":"styles_heroContainer__ubqGf","heroImage":"styles_heroImage__tPST7","heroContentContainer":"styles_heroContentContainer__DXuGz","heading":"styles_heading__ni4vp","linkBtn":"styles_linkBtn__DBCRf"};

/***/ })

}]);